module.exports = __webpack_public_path__ + "img/10.3e9f77a5.png";